import React from "react";
import { Feature } from "../../../components/Feature/Feature";
import { FeatureCallToActionProps } from "../../../components/Feature/FeatureCallToAction/FeatureCallToAction";
import { ImageProps } from "../../../components/Image/Image.types";
import { Stack, StackBackgroundColor } from "../../../components/Stacks/Stack/Stack";
import { useComponentLogger } from "../../../shared/logging";
import { BaseProps, validateProps } from "../../../shared/props";
import { useViewport } from "../../../styles";

export interface FeatureListItemProps extends BaseProps {
    readonly backgroundColor?: StackBackgroundColor;

    /** Properties of CTA to display. */
    readonly ctaProps?: readonly FeatureCallToActionProps[];

    /** Properties of image to display. */
    readonly imageProps: ImageProps;

    /** Feature header. */
    readonly headerText?: string;

    /** Feature body text. */
    readonly bodyText: string;
}

export const FeatureListItem: React.FC<FeatureListItemProps> = ({
    backgroundColor = "neutralHigh",
    ctaProps,
    imageProps,
    bodyText,
    headerText,
    ...otherProps
}) => {
    useComponentLogger("FeatureListItem", otherProps.id);

    validateProps("FeatureListItem", otherProps);
    const isSmallViewport = ["s", "m"].includes(useViewport());

    return (
        <div role="listitem">
            <Stack backgroundColor={backgroundColor} padding={isSmallViewport ? "0 6px" : "0 16px"}>
                <Feature
                    backgroundType="flat"
                    featureHeading={headerText ? { text: headerText } : undefined}
                    bodyText={bodyText}
                    ctaProps={ctaProps}
                    height="small"
                    imageProps={imageProps}
                    layoutType="2/3"
                />
            </Stack>
        </div>
    );
};
